import React, { memo, useCallback } from "react";

import {
  FlamebearerCall,
  FlamebearerMetrics,
  ProfileType
} from "@platformsh/observability-graph/ContinuousProfiling";

import Dialog from "ds/Dialog";
import * as Table from "ds/Table";

import FlamebearerCallTooltip from "../FlamebearerCallTooltip";

import * as S from "./styles";

type Props = {
  callMetrics: FlamebearerMetrics;
  profileType: ProfileType;
  highlighted: boolean;
  onCallHighlighted: (call: FlamebearerCall | null) => void;
};

const FlamebearerTableRow = ({
  callMetrics,
  profileType,
  highlighted,
  onCallHighlighted
}: Props) => {
  const handleEnter = useCallback(() => {
    onCallHighlighted(callMetrics.call);
  }, [callMetrics.call, onCallHighlighted]);
  const handleLeave = useCallback(() => {
    onCallHighlighted(null);
  }, [onCallHighlighted]);

  return (
    <Dialog
      align="center"
      size="large"
      trigger={
        <S.Tr
          onMouseEnter={handleEnter}
          onMouseLeave={handleLeave}
          highlighted={highlighted}
        >
          <Table.Td width="calc(100% - 180px)">
            {callMetrics.call.label}
          </Table.Td>
          <Table.Td width="180px">
            <S.Progress>
              <S.ProgressBarInclusive
                style={{
                  width: `${Math.round(callMetrics.inclusive.impact * 100)}%`
                }}
              />
              <S.ProgressBarExclusive
                style={{
                  width: `${Math.round(callMetrics.exclusive.impact * 100)}%`
                }}
              />
            </S.Progress>
          </Table.Td>
        </S.Tr>
      }
      link={
        <FlamebearerCallTooltip
          callMetrics={callMetrics}
          profileType={profileType}
        />
      }
    />
  );
};

export default memo(FlamebearerTableRow);
